import { makeActionCreator } from '../../../utilities'
import { HomeConstants } from './home.constants'

export const setPcrList = makeActionCreator(HomeConstants.SET_PCR_LIST, 'docs')
export const setFilteredPcrList = makeActionCreator(HomeConstants.SET_FILTERED_PCR_LIST, 'docs')
export const onSelectPCR = makeActionCreator(HomeConstants.ON_SELECT_PCR, 'pcr')
export const onLoadPCR = makeActionCreator(HomeConstants.ON_LOAD_PCR, 'pcr')
export const filterIncompleteStatus = makeActionCreator(HomeConstants.FILTER_INCOMPLETE)
export const setIncompleteFilter = makeActionCreator(
  HomeConstants.SET_INCOMPLETE_FILTER,
  'filteredPCRDocs',
  'showClearFiltersButton'
)
export const filterCompleteStatus = makeActionCreator(HomeConstants.FILTER_COMPLETE)
export const setCompleteFilter = makeActionCreator(
  HomeConstants.SET_COMPLETE_FILTER,
  'filteredPCRDocs',
  'showClearFiltersButton'
)
export const filterNeedsReviewStatus = makeActionCreator(HomeConstants.FILTER_NEEDS_REVIEW)
export const setNeedsReviewFilter = makeActionCreator(
  HomeConstants.SET_NEEDS_REVIEW_FILTER,
  'filteredPCRDocs',
  'showClearFiltersButton'
)
export const clearFilterStatus = makeActionCreator(HomeConstants.CLEAR_FILTERS)
export const setNewPCR = makeActionCreator(HomeConstants.SET_NEW_PCR, 'pcr')
export const setPcrId = makeActionCreator(HomeConstants.SET_PCRID, 'pcrId')
export const setPcr = makeActionCreator(HomeConstants.SET_PCR, 'pcr')
export const applyFilter = makeActionCreator(HomeConstants.APPLY_FILTERS)
export const upgradePCR = makeActionCreator(HomeConstants.UPGRADE_PCR, 'pcr')
export const setUpgradeStatus = makeActionCreator(HomeConstants.SET_UPGRADE_STATUS, 'upgradeStatus')
export const resetValidations = makeActionCreator(HomeConstants.RESET_VALIDATIONS)
export const resetPCR = makeActionCreator(HomeConstants.RESET_PCR)
export const setAddressType = makeActionCreator(HomeConstants.SET_ADDRESS_TYPE, 'addressTypeSelected')
export const getAllPCRDocs = makeActionCreator(HomeConstants.GET_ALL_PCR_DOCS)
export const deletePCR = makeActionCreator(HomeConstants.DELETE_PCR, 'pcrId')
export const setIsPCROpening = makeActionCreator(HomeConstants.SET_IS_PCR_OPENING, 'isPCROpening')
export const setIsPCRClosing = makeActionCreator(HomeConstants.SET_IS_PCR_CLOSING, 'isPCRClosing')
export const setIsPCRError = makeActionCreator(HomeConstants.SET_IS_PCR_ERROR, 'isPCRError')
export const setIsChartLockedIn = makeActionCreator(HomeConstants.SET_IS_CHART_LOCKED_IN, 'isChartLockedIn')
export const clearSelectedPCR = makeActionCreator(HomeConstants.CLEAR_SELECTED_PCR)
export const resetHomeState = makeActionCreator(HomeConstants.RESET_HOME_STATE)
export const checkForFailedAutoUploads = makeActionCreator(HomeConstants.CHECK_FOR_FAILED_AUTO_UPLOADS)
export const initiateAutoUpload = makeActionCreator(HomeConstants.INITIATE_AUTO_UPLOAD)
